import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { NotificationCenterItem, NotificationCenterPage } from '@/types/notifications';
import type { RootState } from '../store';

type NotificationState = {
  notify: NotificationCenterItem[];
  unreadCount: number;
  currentPage: number;
  lastPage: number;
  total: number;
  connecting: boolean;
};

const initialState: NotificationState = {
  notify: [],
  unreadCount: 0,
  currentPage: 1,
  lastPage: 1,
  total: 0,
  connecting: false,
};

export const notification = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    getNotification(state, action: PayloadAction<NotificationCenterPage>) {
      state.notify = action.payload.data;
      state.unreadCount = action.payload.unreadCount;
      state.currentPage = action.payload.current_page ?? 1;
      state.lastPage = action.payload.last_page ?? 1;
      state.total = action.payload.total ?? action.payload.data.length;
      state.connecting = true;
    },
    changeNotificationStatus(state, action: PayloadAction<{ id: number; readAt: string }>) {
      const item = state.notify.find((candidate) => candidate.id === action.payload.id);
      if (item && !item.readAt) {
        item.readAt = action.payload.readAt;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    deleteNotification(state, action: PayloadAction<number[]>) {
      state.notify = state.notify.filter((item) => !action.payload.includes(item.id));
      state.total = Math.max(0, state.total - action.payload.length);
    },
    disconnect() {
      return initialState;
    },
  },
});

export const { getNotification, changeNotificationStatus, deleteNotification, disconnect } = notification.actions;
export const getNotificationSelector = (store: RootState) => store.notification;
export default notification.reducer;
